import React, { useState, useEffect } from "react";
import { HiOutlineMail } from "react-icons/hi";
import { IoIosCall } from "react-icons/io";
import { useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import { Captcha } from "./Captcha";

const ContactUs = () => {
  const generateCaptcha = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 5; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return result;
  };
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [captchaInput, setCaptchaInput] = useState("");
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    watch,
    setError,
    reset,
  } = useForm();

  const handlePhoneChange = (value, data) => {
    setValue("phoneNumber", value); // sets value for react-hook-form
    if (!/^(\+)?[0-9]{10,15}$/.test(value)) {
      setError("phoneNumber", {
        type: "manual",
        message: "Please enter a valid phone number.",
      });
    } else {
      setError("phoneNumber", {
        type: "manual",
        message: "",
      });
    }
  };

  useEffect(() => {
    register("phoneNumber", {
      required: "Please enter your phone number.",
      pattern: {
        value: /^(\+)?[0-9]{10,15}$/,
        message: "Please enter a valid phone number.",
      },
    });
  }, [register]);

  const reloadCaptcha = () => {
    setCaptcha(generateCaptcha());
  };

  useEffect(() => {
    setCaptcha(generateCaptcha());
  }, []);

  const onSubmit = (data) => {
    console.log("Data for my form ", data);
    if (captcha !== captchaInput) {
      toast.error("Captcha is incorrect, please try again.");
      return;
    }
    toast.success("Successully Submitted", {
      style: {
        border: "1px solid #713200",
        padding: "16px",
        color: "#4f1951",
      },
      iconTheme: {
        primary: "#013220",
        secondary: "#FFFAEE",
      },
    });
    setCaptcha(generateCaptcha());
    setCaptchaInput("");
    reset();
  };
  const handleClick = () => {
    console.log("clicking on my form");
  };
  return (
    <div id="contact-us" className="dark:bg-dark">
      <div className="relative text-center">
        <h1 className="text-4xl py-[50px] font-extrabold md:text-7xl font-mono text-center dark:text-light text-[#4f1951] leading-normal">
          Contact Us
        </h1>
        <div
          className="dark:bg-custom-gradient"
          style={{
            position: "absolute",
            width: "320px",
            height: "157.05px",
            left: "50%", // Center horizontally
            top: "50%", // Center vertically
            transform: "translate(-50%, -50%) matrix(1, 0, -0.03, 1, 0, 0)", // Adjust for precise positioning
            opacity: 0.2,
            filter: "blur(34px)",
            borderRadius: "50%",
            zIndex: "0", // Ensure it's behind the text
          }}
        ></div>
      </div>

      <div className="flex flex-col my-[100px] justify-between items-start xl:flex-row px-2 md:px-[150px]">
        <div className="w-full xl:w-[50%] flex flex-col gap-10">
          <div className="flex flex-col gap-1">
            <p className="text-[#451644] dark:text-dimWhite font-bold text-3xl leading-normal ">
              For wherever you need to go next.
            </p>
            <p className="text-[#451644] dark:text-white font-bold text-3xl leading-normal ">
              Gogibus will lead you there.
            </p>
          </div>

          <div className="xl:w-[70%] ">
            <p className="font-semibold font-mono dark:text-white">
              Get in touch to find out how Gogibus can lead your next evolution.
              Unlock the full potential of your organisation, with specialised
              services and tailored solutions to achieve your goals.
            </p>
          </div>

          <div className="flex flex-col gap-5 xl:flex-row justify-between xl:w-[75%] items-start xl:items-center">
            <div className="flex flex-row gap-2 items-center justify-center">
              <HiOutlineMail className="dark:text-white text-dark" size={24} />
              <p className="dark:text-white text-dark">info@gogibus.com.au</p>
            </div>
            <div className="flex flex-row gap-2 items-center justify-center">
              <IoIosCall className="dark:text-white text-dark" size={24} />
              <p className="dark:text-white text-dark">+61 2 9657 0999</p>
            </div>
          </div>
        </div>
        <div className="w-full mt-10 flex flex-col gap-3 xl:mt-0 xl:w-[50%]">
          <h1 className="text-[#451644] dark:text-white font-bold text-3xl leading-normal ">
            Enter your details
          </h1>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col items-center"
          >
            <div className="flex  w-11/12 flex-col space-y-2">
              <label
                htmlFor="fullName"
                className="text-black dark:text-white  font-extrabold font-sans text-md"
              >
                Name <sup className="text-pink-200">*</sup>
              </label>
              <input
                id="fullName"
                placeholder="Enter your full name"
                {...register("fullName", {
                  required: "Please add your full name.", // Adding custom error message
                })}
                className="form-style2  w-full"
              />
              {errors.fullName && (
                <span className="ml-2 text-sx tracking-wide text-pink-200">
                  {errors.fullName.message}
                </span>
              )}
            </div>
            <div className="flex py-3 w-11/12 justify-between gap-[10px] items-center flex-col ss:flex-row ">
              <div className="w-full ss:w-[50%] ss:h-[100px]">
                <label
                  htmlFor="phoneNumber"
                  className="text-black dark:text-white  font-extrabold font-sans text-md"
                >
                  Your Phone Number <sup className="text-pink-200">*</sup>
                </label>

                <PhoneInput
                  country={"au"}
                  buttonStyle={{
                    border: "1px solid black",
                    borderRadius: "5px",
                  }}
                  id="phoneNumber"
                  value={watch("phoneNumber")}
                  onChange={handlePhoneChange}
                  placeholder="Enter your phone number"
                  inputProps={{
                    name: "phoneNumber",
                    required: true,
                    placeholder: "Enter your phone number",
                    className:
                      "rounded-lg p-3  text-[16px] leading-[24px] text-richblack-900 shadow-[0_1px_0_0] shadow-white/50 placeholder:text-richblack-500 border-richblack-700 border-[1px] focus:outline-none relative w-full !pl-14 rounded-md",
                  }}
                />
                {errors.phoneNumber && (
                  <p className="ml-2 text-sx tracking-wide text-pink-200">
                    {errors.phoneNumber.message}
                  </p>
                )}
              </div>
              <div className="w-full ss:w-[50%] ss:h-[100px]">
                <label
                  htmlFor="email"
                  className="text-black dark:text-white  font-extrabold font-sans text-md"
                >
                  Your Email<sup className="text-pink-200">*</sup>
                </label>
                <input
                  type="email"
                  id="email"
                  placeholder="Enter your email"
                  {...register("email", {
                    required: true,
                    pattern: {
                      value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                      message: "Please enter a valid email address.",
                    },
                  })}
                  className="form-style2 w-full"
                />
                {errors.email && (
                  <p className="ml-2  text-sx tracking-wide text-pink-200">
                    {errors.email.message}
                  </p>
                )}
              </div>
            </div>

            <div className="flex w-11/12 py-3  flex-col space-y-2">
              <label
                htmlFor="message"
                className="text-black dark:text-white  font-extrabold font-sans text-md"
              >
                Message <sup className="text-pink-200">*</sup>
              </label>
              <textarea
                id="message"
                placeholder="Enter your message here"
                {...register("message", { required: true })}
                rows={6}
                className="form-style2 w-full resize-x-none"
              />
              {errors.message && (
                <span className="ml-2 text-sx tracking-wide text-pink-200">
                  Please add feedback here.
                </span>
              )}
            </div>
            {/* Checkbox for privacy policy agreement */}
            <div className="flex w-11/12  flex-col py-3">
              <div className="flex flex-row items-center justify-center">
                <input
                  type="checkbox"
                  id="privacyPolicy"
                  {...register("privacyPolicy", {
                    required: "You must agree to the Privacy Policy.",
                  })}
                  className="form-checkbox h-4 w-4 text-black" // Adjust the styling as needed
                />
                <label
                  htmlFor="privacyPolicy"
                  className="text-black dark:text-white  font-medium font-sans text-md ml-2"
                >
                  I agree to Gogibus using the personal information I have
                  provided in accordance with{" "}
                  <Link to="/privacy" className="text-yellow-400">
                    Gogibus's Privacy Policy.*
                  </Link>
                </label>
              </div>
              {errors.privacyPolicy && (
                <span className="mt-2 text-sx tracking-wide text-pink-200">
                  {errors.privacyPolicy.message}
                </span>
              )}
            </div>
            {/* captcha */}

            <div className="flex w-11/12 items-center justify-center flex-col sm:flex-row gap-3 py-3">
              <Captcha value={captcha} onReload={reloadCaptcha} />
              <input
                type="text"
                placeholder="Enter Captcha"
                className="captcha-input"
                value={captchaInput}
                onChange={(e) => setCaptchaInput(e.target.value)}
              />
            </div>

            {/* last two buttons */}
            <div className="mt-6 w-11/12 flex justify-end gap-x-2">
              <button
                type="submit"
                onClick={handleClick}
                className="flex cursor-pointer gap-x-2 items-center rounded-md text-white bg-dark dark:bg-light dark:text-dark  font-semibold hover:scale-90 transition-all duration-300 py-[8px] px-[20px]"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
